"use client";

import Link from "next/link";
import { useEffect, useState } from "react";
import { usePathname } from "next/navigation";
// import json

interface ContactData {
  insta: string;
  tel: string;
  whatsap: string;
  email: string;
  phone: string;
  bale: string;
  eita: string;
  aparat: string;
  link?: string;
}

interface SocialNetwork {
  key: string;
  label: string;
  iconIndex: number;
  link?: string; // اضافه کردن فیلد اختیاری link
}

const socialNetworksInitial: SocialNetwork[] = [
  { key: "eita", label: "ایتا", iconIndex: 0 },
  { key: "aparat", label: "آپارات", iconIndex: 1 },
  { key: "insta", label: "اینستاگرام", iconIndex: 5 },
  { key: "whatsap", label: "واتساپ", iconIndex: 3 },
  { key: "tel", label: "تلگرام", iconIndex: 2 },
  { key: "bale", label: "بله", iconIndex: 6 },
  { key: "email", label: "ایمیل", iconIndex: 4 },
  { key: "phone", label: "شماره تماس", iconIndex: 7 },
];


const icons = [
  "M5.968 23.942a6.624 6.624 0 0 1-2.332-.83c-1.62-.929-2.829-2.593-3.217-4.426-.151-.717-.17-1.623-.15-7.207C.288 5.47.274 5.78.56 4.79c.142-.493.537-1.34.823-1.767C2.438 1.453 3.99.445 5.913.08c.384-.073.94-.08 6.056-.08 6.251 0 6.045-.009 7.066.314a6.807 6.807 0 0 1 4.314 4.184c.33.937.346 1.087.369 3.555l.02 2.23-.391.268c-.558.381-1.29 1.06-2.316 2.15-1.182 1.256-2.376 2.42-2.982 2.907-1.309 1.051-2.508 1.651-3.726 1.864-.634.11-1.682.067-2.302-.095-.553-.144-.517-.168-.726.464a6.355 6.355 0 0 0-.318 1.546l-.031.407-.146-.03c-1.215-.241-2.419-1.285-2.884-2.5a3.583 3.583 0 0 1-.26-1.219l-.016-.34-.309-.284c-.644-.59-1.063-1.312-1.195-2.061-.212-1.193.34-2.542 1.538-3.756 1.264-1.283 3.127-2.29 4.953-2.68.658-.14 1.818-.177 2.403-.075 1.138.198 2.067.773 2.645 1.639.182.271.195.31.177.555a.812.812 0 0 1-.183.493c-.465.651-1.848 1.348-3.336 1.68-2.625.585-4.294-.142-4.033-1.759.026-.163.04-.304.031-.313-.032-.032-.293.104-.575.3-.479.334-.903.984-1.05 1.607-.036.156-.05.406-.034.65.02.331.053.454.192.736.092.186.275.45.408.589l.24.251-.096.122a4.845 4.845 0 0 0-.677 1.217 3.635 3.635 0 0 0-.105 1.815c.103.461.421 1.095.739 1.468.242.285.797.764.886.764.024 0 .044-.048.044-.106.001-.23.184-.973.326-1.327.423-1.058 1.351-1.96 2.82-2.74.245-.13.952-.47 1.572-.757 1.36-.63 2.103-1.015 2.511-1.305 1.176-.833 1.903-2.065 2.14-3.625.086-.57.086-1.634 0-2.207-.368-2.438-2.195-4.096-4.818-4.37-2.925-.307-6.648 1.953-8.942 5.427-1.116 1.69-1.87 3.565-2.187 5.443-.123.728-.169 2.08-.093 2.75.193 1.704.822 3.078 1.903 4.156a6.531 6.531 0 0 0 1.87 1.313c2.368 1.13 4.99 1.155 7.295.071.996-.469 1.974-1.196 3.023-2.25 1.02-1.025 1.71-1.88 3.592-4.458 1.04-1.423 1.864-2.368 2.272-2.605l.15-.086-.019 3.091c-.018 2.993-.022 3.107-.123 3.561-.6 2.678-2.54 4.636-5.195 5.242l-.468.107-5.775.01c-4.734.008-5.85-.002-6.19-.056z",
  "M10 8.64L15.27 12 10 15.36V8.64zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z",
  "M22 2L11 13M22 2l-7 20-4-9-9-4 20-7z",
  "M3 21l1.65-3.8a9 9 0 1 1 3.4 2.9L3 21Z M9 10a.5.5 0 0 0 1 0V9a.5.5 0 0 0-1 0v1a5 5 0 0 0 5 5h1a.5.5 0 0 0 0-1h-1a.5.5 0 0 0 0 1",
  "M22 7l-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7 M2 4h20v16H2z",
  "M2 2h20v20H2z M12 8a4 4 0 1 0 0 8 4 4 0 0 0 0-8z M17.5 6.5h.01",
  "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z M8 12L11 15L16 9",
  "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm0 14.2c-2.5 0-4.71-1.28-6-3.22.03-1.99 4-3.08 6-3.08 1.99 0 5.97 1.09 6 3.08-1.29 1.94-3.5 3.22-6 3.22z"
];



function ContactFix() {

  const [contact, setContact] = useState<ContactData>({
    insta: "",
    tel: "",
    whatsap: "",
    email: "",
    phone: "",
    bale: "",
    eita: "",
    aparat: "",
  });

  const [open, setOpen] = useState(false);

  const [finalsocial, setFinalsocial] = useState([])

  useEffect(() => {
    const fetchContactData = async () => {
      try {
        const response = await fetch('/api/fix-contact');
        if (response.ok) {
          const data = await response.json();

          if (!data || data.length === 0) return;

          setContact(data);
        }
      } catch (error) {
        console.error('Error fetching contact data:', error);
      }
    };

    fetchContactData();
  }, []);

  const [socialNetworksWithLinks, setSocialNetworksWithLinks] = useState<SocialNetwork[]>([]);

  useEffect(() => {
    const updatedSocialNetworks: SocialNetwork[] = socialNetworksInitial.map((social) => {
      // بررسی می‌کنیم که آیا کلید social در contact وجود دارد و مقدار آن خالی نیست
      if (contact[social.key as keyof ContactData] && contact[social.key as keyof ContactData] !== "") {
        // اگر مقدار داشت، آن را به عنوان link اضافه می‌کنیم
        return {
          ...social,
          link: contact[social.key as keyof ContactData],
        };
      }
      // اگر مقدار نداشت، همان آیتم قبلی را برمی‌گردانیم
      return social;
    });

    setSocialNetworksWithLinks(updatedSocialNetworks);
    // console.log("Updated Social Networks:", updatedSocialNetworks);
  }, [contact])

  const pathname = usePathname();

  const isInUserPanel = pathname.includes("/userPanel");
  const isInLogin = pathname.includes("/login") || pathname.includes("/forgot-password");
  
  if (isInUserPanel || isInLogin) {
    return
  }


  return (
    <>
      <div className={`contactFix ${open ? "open" : ""}`}>
        <button
          onClick={() => setOpen(!open)}
          className="ccdiv"
        >
          <i className={`${!open ? 'ri-chat-ai-line' : 'ri-close-line'}`}></i>
        </button>

        <div className="socalsall">
          {socialNetworksWithLinks.map((social: any, index) => {
            if (!social.link) { return }
            return (
              <Link
                key={social.key || index}
                href={social.key === 'phone' ? `tel:${social.link}` : `http://${social.link}`}
                className="sochial"
                target="_blank"
                rel="noopener noreferrer"
              >
                <div className="svg ccdiv">
                  {/* بررسی نوع آیکون (مسیر فایل یا کلاس remixicon) */}
                  {social.icon && (social.icon.startsWith('ri-') || social.icon.includes('.svg')) ? (
                    <i className={`${social.icon || 'ri-link'} text-xl`}></i>
                  ) : (
                    <svg xmlns="http://www.w3.org/2000/svg" className="text-[var(--foreground)] hover:bg-text-red-500 transition-colors duration-300" width="20" height="28" viewBox="0 0 24 24" fill="none" stroke="var(--foreground)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                      <path d={icons[social.iconIndex]}></path>
                    </svg>
                  )}
                </div>
                <p>{social.label}</p>
              </Link>
            )
          })}
        </div>
      </div>
    </>
  );
}

export default ContactFix;